/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';
import {cpdsMediaQueryVals} from "components/common/cpds/token/shared/common";

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} 

Start styles for component here
Your Styles goes here  
End styles for component here

Styles overrides - Do not Remove This Code Block
Data feed styles overrides goes here

// Your Styles goes here and use token ex: ${token?.button_primary_background_color}

*/

const breakpoints = {
  small: `(max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit})`,
  medium: `(max-width: ${cpdsMediaQueryVals.cpds_medium_upper_limit})`,
  large: `(max-width: ${cpdsMediaQueryVals.cpds_large_upper_limit})`,
  largeExtended: `(min-width: ${cpdsMediaQueryVals.cpds_large_extended_lower_limit})`,
};

const columns = {
  small: 6,
  medium: 12,
  large: 12,
  largeExtended: 12,
}

const marginX = {
  small: 16,
  medium: 40,
  large: 56,
  largeExtended: 56,
}

const gutter = {
  small: 8,
  medium: 24,
  large: 40,
  largeExtended: 40,
}

const maxWidth = {
  small: '100%',
  medium: '100%',
  large: 1568,
  largeExtended: 1568,
}

const sectionTitleSpacing = {
  small: 24,
  medium: 40,
  large: 56,
  largeExtended: 64,
}



const CpdsBoxLayoutStyleTag = styled.div`
  ${({ theme: { styles: { cpds } }, columnsCount, axis, ...props }) => {
    return css`
      
      @media ${breakpoints.largeExtended} {
        --cpds-box-layout-gutter-space: ${(columns.largeExtended - 1) * gutter.largeExtended}px;
        --cpds-box-layout-margin-x-space: ${2 * marginX.largeExtended}px;
        --cpds-box-layout-column-width: calc((min(100vw, ${maxWidth.largeExtended}px) - (var(--cpds-box-layout-margin-x-space)) - (var(--cpds-box-layout-gutter-space))) / ${columns.largeExtended});

        height: 300px;
        width: calc((var(--cpds-box-layout-column-width) * ${columnsCount}) + (${(columnsCount - 1) * gutter.largeExtended}px));
        max-width: ${maxWidth.largeExtended}px;
        margin: 0 ${marginX.largeExtended}px;
        
        .section-title {
          margin-bottom: ${sectionTitleSpacing.largeExtended}px;
        }
      }
      
      @media ${breakpoints.large} {
        --cpds-box-layout-gutter-space: ${(columns.large - 1) * gutter.large}px;
        --cpds-box-layout-margin-x-space: ${2 * marginX.large}px;
        --cpds-box-layout-column-width: calc((min(100vw, ${maxWidth.large}px) - (var(--cpds-box-layout-margin-x-space)) - (var(--cpds-box-layout-gutter-space))) / ${columns.large});

        height: 300px;
        width: calc((var(--cpds-box-layout-column-width) * ${columnsCount}) + (${(columnsCount - 1) * gutter.large}px));
        max-width: ${maxWidth.large}px;
        margin: 0 ${marginX.large}px;

        .section-title {
          margin-bottom: ${sectionTitleSpacing.large}px;
        }
      }
      
      @media ${breakpoints.medium} {
        --cpds-box-layout-gutter-space: ${(columns.medium - 1) * gutter.medium}px;
        --cpds-box-layout-margin-x-space: ${2 * marginX.medium}px;
        --cpds-box-layout-column-width: calc((100vw - (var(--cpds-box-layout-margin-x-space)) - (var(--cpds-box-layout-gutter-space))) / ${columns.medium});

        height: 300px;
        width: calc((var(--cpds-box-layout-column-width) * ${columnsCount}) + (${(columnsCount - 1) * gutter.medium}px));
        margin: 0 ${marginX.medium}px;

        .section-title {
          margin-bottom: ${sectionTitleSpacing.medium}px;
        }
      }
      
      @media ${breakpoints.small} {
        --cpds-box-layout-gutter-space: ${(columns.small - 1) * gutter.small}px;
        --cpds-box-layout-margin-x-space: ${2 * marginX.small}px;
        --cpds-box-layout-column-width: calc((100vw - (var(--cpds-box-layout-margin-x-space)) - (var(--cpds-box-layout-gutter-space))) / ${columns.small});

        height: 300px;
        width: calc((var(--cpds-box-layout-column-width) * ${columnsCount}) + (${(columnsCount - 1) * gutter.small}px));
        margin: 0 ${marginX.small}px;

        .section-title {
          margin-bottom: ${sectionTitleSpacing.small}px;
        }
      }
      
      position: relative;
      display: flex;
      flex-direction: ${axis === 'vertical' ? 'column' : 'row'};      

      ${props?.styleOverrides}
    `;
  }}
`;

export { CpdsBoxLayoutStyleTag };
